export const API_ENDPOINT = (window.tmtpcSettings
    && window.tmtpcSettings.endpoint)
    || process.env.REACT_APP_API_URL + "/wp-json/"
let preloadedSettings = {}

export async function getSettings() {
    const response = await fetch(API_ENDPOINT + 'tmtpc/v1/get_settings')
	preloadedSettings = await response.json()
    return preloadedSettings
}

export async function sendMail(data = {}) {
    const response = await fetch(API_ENDPOINT + 'tmtpc/v1/send_mail', {
        method: "POST",
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    })
	
    if (response && response.status === 200) {
        return true
    }
    
    throw Error("There was a problem with sending an email!")
}